import { render } from "./dialysis_summary.vue?vue&type=template&id=db50b5e2&scoped=true"
import script from "./dialysis_summary.vue?vue&type=script&lang=js"
export * from "./dialysis_summary.vue?vue&type=script&lang=js"

import "./dialysis_summary.vue?vue&type=style&index=0&id=db50b5e2&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db50b5e2"]])

export default __exports__